import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-094e8463"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center uppercase" }, "BKS", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "flex flex-row flex-wrap p-2" }
const _hoisted_4 = { class: "w-5 pr-3" }
const _hoisted_5 = {
  key: 0,
  class: "formgroup-inline flex w-full align-items-end items-end justify-content-end"
}
const _hoisted_6 = {
  key: 0,
  class: "bg-green-100 m-2 p-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "VPRAVO", -1))
const _hoisted_8 = {
  key: 1,
  class: "bg-yellow-100 m-2 p-2"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "VĽAVO", -1))
const _hoisted_10 = { class: "formgroup-inline w-full" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"formgroup-inline pl-2 w-full\" data-v-094e8463><div class=\"text-xs font-light text-500 w-11rem\" data-v-094e8463>(výška balkóna do 1.7m </div><div class=\"text-xs font-light text-500 ml-2 w-1rem\" data-v-094e8463> 6 </div><div class=\"text-xs font-light text-500 ml-1\" data-v-094e8463>mm) </div></div><div class=\"formgroup-inline pl-2 w-full\" data-v-094e8463><div class=\"text-xs font-light text-500 w-11rem\" data-v-094e8463>(výška balkóna od 1.7m do 2.2m </div><div class=\"text-xs font-light text-500 ml-2 w-1rem\" data-v-094e8463> 8 </div><div class=\"text-xs font-light text-500 ml-1\" data-v-094e8463>mm) </div></div><div class=\"formgroup-inline pl-2 w-full\" data-v-094e8463><div class=\"text-xs font-light text-500 w-11rem\" data-v-094e8463>(výška balkóna nad 2.2m </div><div class=\"text-xs font-light text-500 ml-2 w-1rem\" data-v-094e8463>10 </div><div class=\"text-xs font-light text-500 ml-1\" data-v-094e8463>mm) </div></div>", 3)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"formgroup-inline pl-2 w-full\" data-v-094e8463><div class=\"text-xs font-light text-500 w-11rem\" data-v-094e8463>(štandard pri BKS </div><div class=\"text-xs font-light text-500 ml-2 w-3rem\" data-v-094e8463>128 </div><div class=\"text-xs font-light text-500 ml-1\" data-v-094e8463>mm) </div></div><div class=\"formgroup-inline pl-2 w-full\" data-v-094e8463><div class=\"text-xs font-light text-500 w-11rem\" data-v-094e8463>(profily s plastovými kolieskami </div><div class=\"text-xs font-light text-500 ml-2 w-3rem\" data-v-094e8463>170 </div><div class=\"text-xs font-light text-500 ml-1\" data-v-094e8463>mm) </div></div><div class=\"formgroup-inline pl-2 w-full\" data-v-094e8463><div class=\"text-xs font-light text-500 w-11rem\" data-v-094e8463>(profily s oceľovými kolieskami </div><div class=\"text-xs font-light text-500 ml-2 w-3rem\" data-v-094e8463>175, 177 </div><div class=\"text-xs font-light text-500 ml-1\" data-v-094e8463>mm) </div></div>", 3)
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"formgroup-inline pl-2 w-full\" data-v-094e8463><div class=\"text-xs font-light text-500 w-5rem\" data-v-094e8463>(čierne krytky </div><div class=\"text-xs font-light text-500 ml-0 w-1rem\" data-v-094e8463>15 </div><div class=\"text-xs font-light text-500 ml-0\" data-v-094e8463>mm, </div><div class=\"text-xs font-light text-500 w-5rem ml-2\" data-v-094e8463>sivé krytky </div><div class=\"text-xs font-light text-500 ml-0 w-1rem\" data-v-094e8463>16 </div><div class=\"text-xs font-light text-500 ml-0\" data-v-094e8463>mm) </div></div>", 1)
const _hoisted_18 = { class: "w-5 pr-3" }
const _hoisted_19 = {
  key: 0,
  style: {"color":"var(--red-500)"}
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "w-2"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputGroupAddon = _resolveComponent("InputGroupAddon")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_row_input = _resolveComponent("row-input")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border-round-lg border-1", `${$props.typeWall === $data.position.FRONT ? 'border-pink-500' : $props.typeWall === $data.position.LEFT ? 'border-cyan-500' : 'border-indigo-500'}`])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["surface-border border-round-top-lg justify-content-center", `${$props.typeWall === $data.position.FRONT ? 'bg-pink-300' : $props.typeWall === $data.position.LEFT ? 'bg-cyan-300' : 'bg-indigo-300'}`])
    }, _hoisted_2, 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_InputGroup, { class: "h-2rem" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputGroupAddon, { class: "w-7 uppercase font-medium text-xs text-700 surface-400" }, {
              default: _withCtx(() => [
                _createTextVNode("Názov")
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroupAddon, { class: "w-3 uppercase font-medium text-xs text-700 surface-400" }, {
              default: _withCtx(() => [
                _createTextVNode("Zadaj")
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroupAddon, { class: "w-2 uppercase font-medium text-xs text-700 surface-400" }, {
              default: _withCtx(() => [
                _createTextVNode("Jednotky")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_row_input, {
          name: "width",
          id: "width",
          required: "true",
          labelFront: "Šírka balkóna/Lodžie",
          labelBack: "[mm]",
          defaultValue: this.wall.width,
          type: "number",
          ref: "width",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "onNewWallValue"]),
        _createVNode(_component_row_input, {
          name: "height",
          id: "height",
          required: "true",
          labelFront: "Výša balkóna/Lodžie",
          labelBack: "[mm]",
          defaultValue: this.wall.height,
          type: "number",
          ref: "height",
          validationAlert: !this.validationOK,
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "validationAlert", "onNewWallValue"]),
        _createVNode(_component_row_input, {
          name: "framesCount",
          id: "framesCount",
          required: "true",
          labelFront: "Počet krídel skiel",
          labelBack: "[ks]",
          defaultValue: this.wall.framesCount,
          type: "number",
          ref: "framesCount",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "onNewWallValue"]),
        _createVNode(_component_row_input, {
          name: "openingDirection",
          id: "openingDirection",
          labelFront: "Otváranie skiel",
          labelBack: "[-]",
          defaultValue: this.wall.openingDirection,
          type: "select",
          option: this.store.opening_direction_bks,
          ref: "openingDirection",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "option", "onNewWallValue"]),
        (this.store.order.type.code == $options.TypeCode.NB_F_D)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (this.wall.openingDirection == $options.OpeningDirection.LEFT)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createTextVNode("Pozícia dverí "),
                    _hoisted_7
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createTextVNode("Pozícia dverí "),
                    _hoisted_9
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_row_input, {
            name: "glassTemperedThickness",
            id: "glassTemperedThickness",
            labelFront: "Hrúbka kalených skiel",
            labelBack: "[mm]",
            defaultValue: this.wall.glassTemperedThickness,
            type: "select",
            option: this.store.glass_tempered_thickness,
            ref: "glassTemperedThickness",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "option", "onNewWallValue"]),
          _hoisted_11
        ]),
        _createVNode(_component_row_input, {
          name: "caseType",
          id: "caseType",
          labelFront: "Výška púzdra",
          labelBack: "[mm]",
          defaultValue: this.wall.caseType,
          type: "select",
          option: this.store.case_types,
          ref: "caseType",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "option", "onNewWallValue"]),
        (this.wall.caseType == $options.Models.CaseType.NONE)
          ? (_openBlock(), _createBlock(_component_row_input, {
              key: 1,
              name: "caseThickness",
              id: "caseThickness",
              labelFront: "Odčítanie púzdra na sklo",
              labelBack: "[mm]",
              defaultValue: this.wall.caseThickness,
              type: "select",
              option: this.store.case_type_range_0,
              ref: "caseThickness",
              onNewWallValue: $options.ChangeInput
            }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
          : _createCommentVNode("", true),
        (this.wall.caseType == $options.Models.CaseType.CASE60)
          ? (_openBlock(), _createBlock(_component_row_input, {
              key: 2,
              name: "caseThickness",
              id: "caseThickness",
              labelFront: "Odčítanie púzdra na sklo",
              labelBack: "[mm]",
              defaultValue: this.wall.caseThickness,
              type: "select",
              option: this.store.case_type_range_60,
              ref: "caseThickness",
              onNewWallValue: $options.ChangeInput
            }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
          : _createCommentVNode("", true),
        (this.wall.caseType == $options.Models.CaseType.CASE90)
          ? (_openBlock(), _createBlock(_component_row_input, {
              key: 3,
              name: "caseThickness",
              id: "caseThickness",
              labelFront: "Odčítanie púzdra na sklo",
              labelBack: "[mm]",
              defaultValue: this.wall.caseThickness,
              type: "select",
              option: this.store.case_type_range_90,
              ref: "caseThickness",
              onNewWallValue: $options.ChangeInput
            }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_row_input, {
          name: "anotherProfilesThickness",
          id: "anotherProfilesThickness",
          labelFront: "Odčítanie iných profilov",
          labelBack: "[mm]",
          type: "number",
          defaultValue: this.wall.anotherProfilesThickness,
          ref: "anotherProfilesThickness",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "onNewWallValue"]),
        _hoisted_14,
        _createVNode(_component_row_input, {
          name: "capType",
          id: "capType",
          labelFront: "Typ krytiek",
          labelBack: "[mm]",
          defaultValue: this.wall.capType,
          type: "select",
          option: this.store.cap_type,
          ref: "capType",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "option", "onNewWallValue"]),
        _hoisted_17,
        _createVNode(_component_row_input, {
          name: "profilesColor",
          id: "profilesColor",
          labelFront: "Farba profilov",
          labelBack: "[-]",
          defaultValue: this.wall.profilesColor,
          type: "text",
          ref: "profilesColor",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "onNewWallValue"]),
        _createVNode(_component_row_input, {
          name: "glazingType",
          name2: "glazingTypeAttribute",
          id: "glazingType",
          labelFront: "Stopsol",
          labelBack: "farba",
          defaultValue: this.wall.glazingType,
          defaultValue2: this.wall.glazingTypeAttribute,
          type: "select-select",
          option: this.store.glazing_type,
          option2: this.store.glazing_type_attribute,
          ref: "glazingType",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "defaultValue2", "option", "option2", "onNewWallValue"]),
        _createVNode(_component_row_input, {
          name: "holes",
          id: "holes",
          labelFront: "Horné diery",
          defaultValue: this.wall.holes,
          type: "checkbox",
          ref: "holes",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "onNewWallValue"]),
        _createVNode(_component_row_input, {
          name: "handle",
          id: "handle",
          labelFront: "Kľučka",
          defaultValue: this.wall.handle,
          type: "checkbox",
          ref: "handle",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "onNewWallValue"]),
        _createVNode(_component_InputGroup, { class: "h-2rem mt-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputGroupAddon, { class: "w-full uppercase font-medium text-sm text-800 bg-gray-300" }, {
              default: _withCtx(() => [
                _createTextVNode("Poznámky")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_InputGroup, null, {
          default: _withCtx(() => [
            _createVNode(_component_TextArea, {
              autoResize: "",
              rows: "2",
              class: "w-full",
              placeholder: "Poznámka ku stene",
              modelValue: this.wall.comment,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.wall.comment) = $event)),
              style: {"background":"#b8d6f0","text-align":"left"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_InputGroup, { class: "h-2rem" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputGroupAddon, { class: "w-full uppercase font-medium text-sm text-800 bg-red-300" }, {
              default: _withCtx(() => [
                _createTextVNode("Výstupné údaje ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_InputGroup, { class: "h-3rem" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
              default: _withCtx(() => [
                _createTextVNode("Predbežný výpočet šírky všetkých profilov ")
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(this.wall.profilesLength), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
              default: _withCtx(() => [
                _createTextVNode("[mm]")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_InputGroup, { class: "h-2rem mt-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
              default: _withCtx(() => [
                _createTextVNode("Šírka profilu ")
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(this.wall.singleProfileLength), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
              default: _withCtx(() => [
                _createTextVNode("[mm]")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_row_input, {
          name: "manualSingleProfileLength",
          id: "manualSingleProfileLength",
          labelFront: "Zadaná šírka profilu",
          labelBack: "[mm]",
          defaultValue: this.wall.manualSingleProfileLength,
          type: "number",
          ref: "manualSingleProfileLength",
          backgroundText: "bg-gray-300",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "onNewWallValue"]),
        _createVNode(_component_row_input, {
          name: "customDoor",
          id: "customDoor",
          labelFront: "Vlastná šírka PROFILU dverí",
          defaultValue: this.wall.customDoor,
          type: "checkbox",
          ref: "customDoor",
          onNewWallValue: $options.ChangeInput
        }, null, 8, ["defaultValue", "onNewWallValue"]),
        (this.wall.customDoor)
          ? (_openBlock(), _createBlock(_component_row_input, {
              key: 0,
              name: "customDoorProfileWidth",
              id: "customDoorProfileWidth",
              labelFront: "Zadaná šírka PROFILU dverí",
              labelBack: "[mm]",
              defaultValue: this.wall.customDoorProfileWidth,
              type: "number",
              ref: "customDoorProfileWidth",
              backgroundText: "bg-gray-300",
              onNewWallValue: $options.ChangeInput
            }, null, 8, ["defaultValue", "onNewWallValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_InputGroup, { class: "h-2rem mt-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start bg-gray-300" }, {
              default: _withCtx(() => [
                _createTextVNode(" Prepočtová šírka "),
                (this.getTotalLengthDiff() > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "  -" + _toDisplayString(this.getTotalLengthDiff()) + "mm! ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  style: _normalizeStyle(this.getTotalLengthDiff() > 0 ? 'color: var(--red-500)':'')
                }, _toDisplayString(this.wall.totalProfilesLength), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
              default: _withCtx(() => [
                _createTextVNode("[mm]")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_InputGroup, { class: "h-2rem" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputGroupAddon, { class: "w-full uppercase font-medium text-sm text-800 bg-red-100" }, {
              default: _withCtx(() => [
                _createTextVNode("Výpočet skutočnej šírky skla ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.wall.bksGlasses, (g, i) => {
          return (_openBlock(), _createBlock(_component_InputGroup, {
            class: "h-2rem",
            key: g.id
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(i + 1) + ". sklo ", 1),
                  (g.door)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_20, " - dvere"))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(g.width), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_InputGroup, { class: "h-2rem mt-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputGroupAddon, { class: "w-7 font-medium text-base text-800 justify-content-start bg-red-100" }, {
              default: _withCtx(() => [
                _createTextVNode("Výpočet výšky skiel ")
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(this.wall.computedGlassHeight), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
              default: _withCtx(() => [
                _createTextVNode("[mm]")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (this.wall.customDoor)
          ? (_openBlock(), _createBlock(_component_InputGroup, {
              key: 1,
              class: "h-2rem mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Šírka profilov bez dverí ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(this.wall.centerRailingWidth), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode("[mm]")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (this.store.order.id > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            (this.store.pdfProductionLink !== '')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: this.store.pdfProductionLink,
                  class: "mr-5 ml-5",
                  target: "_blank"
                }, [
                  _createVNode(_component_PrimevueButton, {
                    label: "Zobraziť výrobný list",
                    text: "",
                    raised: "",
                    class: "uppercase",
                    icon: "pi pi-eye"
                  })
                ], 8, _hoisted_22))
              : _createCommentVNode("", true),
            (this.store.pdfProductionPrintLink !== '' )
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: this.store.pdfProductionPrintLink,
                  class: "mr-5 ml-5",
                  target: "_blank"
                }, [
                  _createVNode(_component_PrimevueButton, {
                    label: "Tlačiť výrobný list",
                    text: "",
                    raised: "",
                    class: "uppercase",
                    icon: "pi pi-print",
                    severity: "success"
                  })
                ], 8, _hoisted_23))
              : _createCommentVNode("", true),
            (this.store.pdfBksProfileLink !== '' )
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: this.store.pdfBksProfileLink,
                  class: "mr-5 ml-5",
                  target: "_blank"
                }, [
                  _createVNode(_component_PrimevueButton, {
                    label: "Zobraziť BKS profil",
                    text: "",
                    raised: "",
                    class: "uppercase",
                    icon: "pi pi-eye"
                  })
                ], 8, _hoisted_24))
              : _createCommentVNode("", true),
            (this.store.pdfBksProfilePrintLink !== '' )
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  href: this.store.pdfBksProfilePrintLink,
                  class: "mr-5 ml-5 mb-5",
                  target: "_blank"
                }, [
                  _createVNode(_component_PrimevueButton, {
                    label: "Tlačiť BKS profil",
                    text: "",
                    raised: "",
                    class: "uppercase",
                    icon: "pi pi-print",
                    severity: "success"
                  })
                ], 8, _hoisted_25))
              : _createCommentVNode("", true),
            (this.store.dxfGlassesLink !== '' )
              ? (_openBlock(), _createElementBlock("a", {
                  key: 4,
                  href: this.store.dxfGlassesLink,
                  class: "mr-5 ml-5",
                  target: "_blank"
                }, [
                  _createVNode(_component_PrimevueButton, {
                    label: "Stiahnuť DXF",
                    text: "",
                    raised: "",
                    class: "uppercase",
                    icon: "pi pi-download"
                  })
                ], 8, _hoisted_26))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}